<app-content-card
  [title]="title"
  [subtitle]="subtitle"
  [icon]="icon"
  [color]="color"
  [showShadow]="showShadow"
  [margin]="margin"
  [width]="width"
  [height]="height"
>
  <!-- Acciones en el encabezado de la tarjeta (un selector de período, por
       ejemplo): se pasan con el atributo card-header-actions. -->
  <ng-container ngProjectAs="[card-header-actions]">
    <ng-content select="[card-header-actions]"></ng-content>
  </ng-container>
  <div
    class="map-container"
    [ngStyle]="{
      height: height
        ? title
          ? subtitle
            ? `calc(${height} - 77px)`
            : `calc(${height} - 55px)`
          : height
        : '100%',
    }"
  >
    @if (loading) {
      <app-loading text="Cargando ubicación..."></app-loading>
    } @else if (mapOptions) {
      <app-mapa-facil-v2
        (mapReady)="onMapReady($event)"
        (entityClick)="onEntityClick($event)"
        [mapId]="nombreMap"
        [showMapSelector]="false"
        [disablePopups]="disablePopups"
      ></app-mapa-facil-v2>
    } @else {
      <app-empty-state
        icon="location_off"
        message="No hay ubicación disponible"
      ></app-empty-state>
    }
  </div>
</app-content-card>
